<template>
  <div class="seomain">
    <div class="tab-content">
      <div class="st-list-box pan-105">
        <div class="st-list-xs" v-for="(v, k) in stlist" :key="k" :index="k">
          <div class="st-list-top-xs" >
<!--              display: flex;align-items: center;justify-content: center;-->
              <el-row :gutter="40" style="height: 49px;" type="flex" justify="space-between" align="middle">
                  <el-col :span="12">
                    <el-row :gutter="40"  >
                        <el-col :span="24">
                            <div class="t-tit-xs-up st-list-left">{{ oi.ordercode }}</div>
                        </el-col>
                        <el-col :span="24">
                            <div class="t-tit-xs-down st-list-left">{{ oi.id }}</div>
                        </el-col>
                    </el-row>
                  </el-col>
                <!-- <el-col :span="12">
                    <div class="t-tit-xs st-list-left">SKU:{{ v.sku }}</div>
                </el-col> -->
                <el-col :span="12" >
                    <div class="t-tit-xs st-list-right">{{oi.status_text}}</div>
                </el-col>
              </el-row>
          </div>

          <div class="st-list-main">
            <p>订单类型：{{ oi.type_text }}</p>
            <p>提 单 人&nbsp;：{{ oi.operator }}</p>
            <p>销 售 员&nbsp;：{{ oi.seller }}</p>
            <p>订单数量：{{ oi.total }}</p>
            <p>客&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;户：{{ oi.clientname }}</p>
            <p>收 件 人&nbsp;：{{ oi.receiver }}</p>
            <p>收货电话：{{ oi.phone }}</p>
            <p>收货地址：{{ oi.address }}</p>
          </div>
          <div class="st-list-bottom-xs" v-for="(item, key) in oi.skulist" :key="key">
              <el-row :gutter="40"  type="flex" justify="space-between">
                <el-col :span="18" >
                    <div class="t-tit-xs st-list-left">SKU：{{ item.sku }}</div>
                </el-col>
                <el-col :span="6">
                    <div class="t-tit-xs st-list-right">{{item.total+'台'}}</div>
                </el-col>
              </el-row>
          </div>
          <div class="st-up-btn" @click="uploadImage" >
              <el-butten class="t-tit-xs">上传发货照片</el-butten>
          </div>
            <div class="st-up-btn"  @click="submitUploadImage">
                <el-butten class="t-tit-xs">提交</el-butten>
            </div>
<!--          <div class="">-->
<!--              <el-image :src="'https://t7.baidu.com/it/u=2604797219,1573897854&fm=193&f=GIF'"></el-image>-->
<!--          </div>-->
<!--          <div class="" style="position: relative;">-->
<!--              <i class="el-icon-error imgIcon"></i>-->
<!--              <el-image :src="'https://t7.baidu.com/it/u=2604797219,1573897854&fm=193&f=GIF'"></el-image>-->
<!--          </div>-->
            <div class="" style="position: relative;" v-for="(item, key) in imageArray" :key="key" >
                <i class="el-icon-error imgIcon" @click="deleteImg(key)" style="background-color: #FFF; border-radius:15px"></i>
                <el-image :src="item"></el-image>

            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from "axios";
    import {Toast} from "vant";
export default {
  components: {},
  props: {},
  data() {
    return {
      stlist: [
          {
              sku:"PC-2022-05-21",
              total:"100",
              inventory_code:"100",
              product_name:"名称",
              brand:"名称",
              model:"model",
              amount:"12345",
          },

      ],
      oi: null,
      orderId:'',
      type: '',
        imageArray:[],
        imageSubmit:[],
    };
  },
  watch: {},
  computed: {},
  methods: {
      deleteImg(index){
          this.imageArray.splice(index, 1);
          this.imageSubmit.splice(index, 1);
      },
    get_order_info: function() {
      let orderUrl = '';
      if(this.type == '1'){
        orderUrl = this.$api.orderInfo1;
      }else if(this.type == '2'){
        orderUrl = this.$api.orderInfo2;
      }else if(this.type == '3'){
        orderUrl = this.$api.orderInfo3;
      }else if(this.type == '4'){
        orderUrl = this.$api.orderInfo4;
      }

      this.$post(orderUrl, {"id":this.orderId}).then((res) => {
          if(res.code == 200){
              this.oi = res.data;
          }else {
              Toast.fail("未发现订单");
          }
      });

    },
      uploadImage: function () {
          let _this = this;
          tt.chooseImage({
              sourceType: ['album', 'camera'],
              count: 5,
              cameraDevice: "front",
              success: res => {
                  // console.log(JSON.stringify(res))
                  // alert(res.tempFilePaths+"====="+res.tempFiles)
                  for (let i = 0; i < res.tempFilePaths.length; i++) {
                      try {
                          tt.getFileSystemManager().readFile({
                              filePath: res.tempFilePaths[i],
                              encoding: "base64",
                              // position: 5,
                              // length: 10,
                              success(re) {
                                  // console.log(re);
                                  let base64Str = 'data:image/png;base64,'+re.data;


                                  //上传
                                  _this.$post(_this.$api.uploadImage, {file: base64Str, type: _this.type}).then((response) => {
                                      // alert(response.data.fullurl);
                                      _this.imageArray.push(response.data.fullurl);
                                      _this.imageSubmit.push(response.data.url);
                                  });

                              },
                              fail(re) {
                                  console.log(`readFile fail: ${JSON.stringify(re)}`);
                              }
                          });
                      }catch (e) {
                          // alert("###"+e)
                      }
                  }
              },
              fail(res) {
                  console.log(JSON.stringify(res))
              }
          })

      },

      submitUploadImage: function (){
          let _this = this;
          if(_this.imageSubmit && _this.imageSubmit.length > 0){
              _this.$post(_this.$api.uploadImage, {ids: _this.orderId, type: _this.type, send_images: _this.imageSubmit.join(',')}).then((response) => {
                  // alert(response.data.fullurl);
                  if(response.code == 200){
                      Toast.success("提交成功");
                      _this.$router.push("/")
                  }else{
                      Toast.fail(response.msg);
                  }

              });
          }else {
              Toast.fail("请上传发货图片");
          }

      }


  },

  created() {
    this.orderId = this.$route.params.id;
    this.type = this.$route.params.type;
    // console.log(this.orderId,'=====-==-=-==-', this.type)
    this.get_order_info();
    // window.h5sdk.ready(function() {
    //   window.h5sdk.biz.navigation.setTitle({ title: "订单详情" });
    // });

      this.$post(this.$api.getSignature, {url:window.location.href}).then((response) => {
          // alert(response.appId+'='+response.timestamp+'-'+response.nonceStr+'-'+response.signature);
          window.h5sdk.config({
              appId: response.appId,         // 必填，应用ID
              timestamp: response.timestamp,      // 必填，生成签名的时间戳，毫秒级
              nonceStr: response.nonceStr,      // 必填，生成签名的随机串
              signature: response.signature,     // 必填，签名
              jsApiList : [
              ],
              onSuccess: function(res) {
                  console.log('h5config init success===== ', res)
                  // 成功回调，可以在成功之后使用 tt.xx jsapi
                  // alert("h5config init success")
              },
              onFail: function() {
                  console.log('h5config init fail===== ')
                  // 失败回调
                  // alert("h5config init fail")
              }
          });
      });



      window.h5sdk.error(error => {
          console.log("error============================="+error)
          // for (var p in error) {
          //     alert(error[p]);
          // }
          // alert("error ==="+error)
      });

  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.tab-content .st-list-xs {
  margin-bottom: 10px;
  background: #fff;
}
.st-list-top-xs {
  background: #51596E;
  text-align: center;
}
.st-list-bottom-xs{
    background: #8496AE;
    margin-top: 10px;
}
.t-tit-xs {
  color: #fff;
  line-height: 2.6;
}
.t-tit-xs-up {
  color: #fff;
  line-height: 1.6;
}
.t-tit-xs-down {
  color: greenyellow;
  line-height: 1;
  font-size: 10px;
}

.st-list-main {
  padding: 10px 15px;
}
.st-list-left {
  text-align: left;
  margin-left: 20px;
}
.st-list-right {
  text-align: right;
  margin-right: 20px;
}
.st-up-btn{
    background: #2A82E4;
    margin: 10px 20px;
    text-align: center;
    border-radius:5px;
}
.tab-tilte.four {
    display: flex;
}
.tab-tilte.four .text-center {
    flex: 1;
}
.imgIcon{
    position: absolute;
    right: 15px;
    top: 10px;
    z-index: 10;
    font-size: 30px;
}
</style>
